import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { PropTypes } from 'prop-types';
import stripePromise from '../../core/utils/stripeProvider';

const StripeElementsWrapper = ({ children }) => (
    <Elements stripe={stripePromise}>
        {children}
    </Elements>
);

StripeElementsWrapper.propTypes = {
    children: PropTypes.node.isRequired,
};

export default StripeElementsWrapper;
